import React from 'react';
import { Map, Grid, Clock, ShieldCheck, FileText, Calendar, AlertTriangle } from 'lucide-react';
export function IncludesSection() {
  const items = [{
    icon: <Map className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-101" />,
    title: 'El mapa rápido de lesiones',
    desc: 'Para dejar de tratar un nervio como músculo, o un tendón como "solo inflamación".'
  }, {
    icon: <Grid className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-102" />,
    title: 'La Matriz 4C completa',
    desc: 'Con indicadores claros para saber en qué fase estás.'
  }, {
    icon: <Clock className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-103" />,
    title: 'Micro-dosis de movimiento (5–12 min)',
    desc: 'Para días con trabajo, estrés, familia y cero ganas.'
  }, {
    icon: <ShieldCheck className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-104" />,
    title: 'Cómo cargar sin romper',
    desc: 'Progresiones simples, descarga, y el error #1 que causa recaídas.'
  }, {
    icon: <FileText className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-105" />,
    title: 'Plantillas por caso',
    desc: 'Tendón, músculo, articulación, lumbar reactivo y síntomas tipo nervio.'
  }, {
    icon: <Calendar className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-106" />,
    title: 'Plan 21 días "Sanar en Movimiento"',
    desc: 'Una ruta para salir del estancamiento sin reiniciar cada lunes.'
  }, {
    icon: <AlertTriangle className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-107" />,
    title: '"Semáforo de evidencia" (sección anti-humo)',
    desc: 'Para no caer en marketing agresivo de "atajos" y saber qué preguntar a un profesional.'
  }];
  return <section className="w-full bg-[#F5F0E6] py-12 px-4 sm:py-16 sm:px-6 md:py-28" data-id="element-108">
      <div className="max-w-4xl mx-auto" data-id="element-109">
        <div className="text-center mb-10 sm:mb-16" data-id="element-110">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif font-bold text-[#4C1D95] mb-3 sm:mb-4" data-id="element-111">
            Qué incluye
          </h2>
          <p className="text-base sm:text-lg text-[#555555]" data-id="element-112">
            Contenido real, usable y directo al grano.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:gap-6" data-id="element-113">
          {items.map((item, i) => <div key={i} className="bg-white p-4 sm:p-6 rounded-xl shadow-sm border border-[#E8E3D9] flex items-start" data-id="element-114">
              <div className="p-2.5 sm:p-3 bg-[#7C3AED]/10 rounded-lg text-[#7C3AED] mr-3 sm:mr-5 flex-shrink-0" data-id="element-115">
                {item.icon}
              </div>
              <div className="min-w-0" data-id="element-116">
                <h3 className="text-base sm:text-xl font-bold text-[#4C1D95] mb-0.5 sm:mb-1" data-id="element-117">
                  {item.title}
                </h3>
                <p className="text-sm sm:text-base text-[#555555]" data-id="element-118">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}